export const title = 'Bidit.kr'
export const CopyRighter = 'InnoG2B Inc.'
export const restEndPoint = 'https://api.bidit.kr/rest'
export const apiEndPoint = 'https://api.bidit.kr/api/v2'
// export const restEndPoint = 'http://localhost:8000/rest'